
<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="data">
        <h2>我的订单</h2>
      </div>
      <!--温馨提示-->
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg" />
          <div>
            <h2>温馨提示</h2>
            <p>1、这里会显示您更多的订单</p>
            <p>2、您还可以进行查看订单详情、搜索已成功订单和取消订单等操作。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <!--温馨提示-->
      <!--温馨提示结束-->
      <div class="search-box">
        <Row style="height: 41px; line-height: 41px">
          <Col
            span="4"
            style="text-align: right"
          > 按订单日期：</Col>
          <Col
            span="12"
            style="box-sizing: border-box !important"
          >
          <DatePicker
            type="daterange"
            :confirm="true"
            :transfer="true"
            :clearable="false"
            size="small"
            class="datepicker"
            v-model="searchDate"
          ></DatePicker>
          </Col>
        </Row>
        <Row style="height: 41px; line-height: 41px">
          <Col
            span="4"
            style="text-align: right"
          > 按商品关键字：</Col>
          <Col span="11">
          <Input
            v-model="searchKey"
            size="small"
            placeholder="输入订单中商品关键字"
            style="width: 295px"
          ></Input>
          </Col>
          <Col span="3">
          <Button
            size="small"
            @click.native="searchEvent"
          >在订单中搜索</Button>
          </Col>
          <Col
            span="6"
            v-show="showResult"
          >
          <label style="margin-left: 10px">搜索结果：<b style="font-size: 14px">{{ total }}</b>
            笔订单</label>
          </Col>
        </Row>
      </div>
      <div
        class="form_wrap white_box"
        style="margin-top: 20px"
      >
        <div
          class="box"
          style="width: 751px"
        >
          <Tabs
            type="card"
            :animated="false"
            v-model="tabIndex"
            @on-click="toggleOrder"
          >
            <TabPane
              :label="tab.label"
              :name="tab.name"
              :key="tab.label"
              v-for="tab in tabList"
            >
              <Table
                class="order-table"
                :columns="column"
                :data="orderList"
                no-data-text="尚无订单"
              ></Table>
              <Page
                v-if="total"
                :total="total"
                show-total
                show-elevator
                @on-change="changePage"
                :current="pageIndex"
                style="float: right; margin-top: 10px"
                :page-size="pageSize"
              ></Page>
            </TabPane>
          </Tabs>
        </div>
        <div class="rr_bottom"></div>
      </div>
    </div>
    <Modal
      v-model="cancelModal"
      width="530"
      title="请输入取消原因"
    >
      <Input
        v-model="reason"
        type="textarea"
        :rows="4"
        style="width: 480px"
      ></Input>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          @click="cancelOrder"
        >确认取消订单</Button>
      </div>
    </Modal>
    <Modal
      v-model="frankingModal"
      width="530"
    >
      <div style="padding: 24px; line-height: 1.5;font-size:16px">{{frankingText}}</div>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          @click.native="frankingHandle"
        >确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  getOrderList,
  orderCancel,
  rogConfirm,
  rogDelay,
  preCancelOrder,
} from "api/order";
import { getSession, parseTime } from "utils/tool";

// 订单状态说明
// -7 已换货 -4 申请换货 -3 申请退货 -2 退货完成 -1 退款 0 等待付款 1 已付款待确认 2 已付款 3 配货中 5 已发货 6 已收货   7 已成功 8 已取消

export default {
  data() {
    return {
      frankingText: "", //邮费提示
      frankingModal: false, // 邮费确认弹窗
      cancelModal: false, // 取消原因弹框
      cancelFlag: true, // 取消标识
      order_id: "", // 取消的订单ID
      reason: "", // 订单取消理由
      searchKey: "",
      searchDate: [],
      tabIndex:
        this.$route.query.status === undefined
          ? "-1"
          : `${this.$route.query.status}`,
      showResult: false,
      tabList: [
        {
          name: "-1",
          label: "所有订单",
        },
        {
          name: "0",
          label: "等待付款",
        },
        // {
        //   name: "1",
        //   label: "已付款待确认",
        // },
        {
          name: "2",
          label: "已付款",
        },
        {
          name: "5",
          label: "已发货",
        },
        {
          name: "8",
          label: "已取消",
        },
        {
          name: "7",
          label: "已成功",
        },
        {
          name: "9",
          label: "搜索结果",
        },
      ],
      column: [
        {
          title: "订单号",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/member/orderInfo",
                        query: {
                          orderId: params.row.orderId,
                          orderSn: params.row.orderNo,
                          isCod: params.row.onlinePay,
                          aux: params.row.auxState,
                        },
                      });
                    },
                  },
                },
                params.row.orderNo
              ),
            ]);
          },
        },
        {
          title: "下单日期",
          align: "center",
          width: 120,
          key: "createTime",
        },
        {
          title: "收货人",
          align: "center",
          width: 60,
          key: "shipName",
        },
        {
          title: "总金额",
          align: "center",
          width: 70,
          key: "orderAmount",
          render: (h, params) => {
            let texts = `￥${params.row.orderAmount.toFixed(2)}`;
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        {
          title: "状态",
          align: "center",
          width: 80,
          key: "statusText",
        },
        {
          title: "付款方式",
          align: "center",
          width: 120,
          key: "paymentName",
        },
        {
          title: "操作",
          align: "center",
          key: "name",
          render: (h, params) => {
            const playBtn = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    let routeData = this.$router.resolve({
                      path: "/pay",
                      query: { orderId: params.row.id },
                    });
                    const tempwindow = window.open();
                    tempwindow.location = routeData.href;
                  },
                },
              },
              "立即付款"
            );
            const cancel = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    // if (
                    //   params.row.status == "2" &&
                    //   params.row.sourceFlag == "3"
                    // ) {
                    //   //已付款的订单 并且是首购商品
                    //   this.$Message.error("首购专区商品已支付订单不能取消");
                    //   return false;
                    // }
                    if (this.cancelFlag) {
                      this.cancelFlag = false;
                      this.order_id = params.row.orderNo;
                      //判断是否自营订单然后弹出确认提示
                      if (params.row.isSelf == 1) {
                        preCancelOrder({ orderNo: params.row.orderNo }).then(
                          ({ resCode, resDesc, data }) => {
                            if (resCode === 1) {
                              if (data.message) {
                                this.frankingText = data.message;
                                this.frankingModal = true;
                              } else {
                                this.cancelModal = true;
                              }
                            } else {
                              this.cancelModal = false;
                              this.$Message.warning(resDesc);
                            }
                          }
                        );
                      } else {
                        this.cancelModal = true;
                      }

                      setTimeout(() => {
                        this.cancelFlag = true;
                      }, 500);
                    }
                  },
                },
              },
              "取消订单"
            );
            const sure = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.rogConfirm(params.row.orderNo);
                  },
                },
              },
              "确认收货"
            );
            const delay = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.rogDelay(params.row.orderNo);
                  },
                },
              },
              "延迟收货"
            );
            const change = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: "/member/returnList",
                      query: {
                        tab: 1,
                      },
                    });
                  },
                },
              },
              "申请退换货"
            );
            const viewBtn = h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: "/member/orderInfo",
                      query: {
                        orderId: params.row.orderId,
                        orderSn: params.row.orderNo,
                        isCod: params.row.onlinePay,
                        aux: params.row.auxState,
                      },
                    });
                  },
                },
              },
              "查看"
            );
            let btns = [];
            if (params.row.status === 12) {
              btns.push(sure); // 确认收货
              if (params.row.auxState !== 1) {
                btns.push(delay); // 延迟收货
              }
            } else if (params.row.status === 7) {
              if (params.row.auxState === 0 || params.row.auxState === 5) {
                btns.push(change); // 申请退换货
              }
            }
            if (params.row.status === 0) {
              if (params.row.onlinePay) {
                btns.push(playBtn); // 立即付款
              }
            }
            if (params.row.status === 0 || params.row.status === 2) {
              if (params.row.auxState !== 5) {
                btns.push(cancel); // 取消订单
              }
            }
            btns.push(viewBtn);
            return h("div", btns);
          },
        },
      ],
      orderList: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
    };
  },
  watch: {
    $route: "changeRoute",
  },
  mounted() {
    this.$nextTick(() => {
      this.toggleOrder(this.tabIndex);
    });
  },
  methods: {
    changeRoute() {
      let status = this.$route.query.status;
      if (this.tabIndex != status && status != undefined) {
        this.tabIndex = status.toString();
        this.toggleOrder(this.tabIndex);
      }
    },
    toggleOrder(status) {
      this.$router.push({ query: { status: status } });
      this.pageIndex = 1;
      this.getOrderList();
    },
    // 延迟收货
    rogDelay(id) {
      this.$Modal.confirm({
        content: "<p>确认延长收货时间？将推迟7天打款给卖家！</p>",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          rogDelay({ orderNo: Number(id) }).then((resp) => {
            if (resp.resCode === 1) {
              this.$Message.success("订单确认延迟成功");
              this.getOrderList();
            } else {
              this.$Message.error(resp.resDesc);
            }
          });
        },
        onCancel: () => {},
      });
    },
    // 取消订单
    cancelOrder() {
      setTimeout(() => {
        if (this.reason.trim() === "") {
          this.$Message.warning("订单取消原因不能为空");
        } else if (this.reason.trim().length > 250) {
          this.$Message.warning("订单取消原因字数不能超过250个");
        } else {
          orderCancel({
            orderNo: this.order_id,
            reason: this.reason,
          }).then((resp) => {
            if (resp.resCode === 1) {
              this.$Message.success("订单取消成功");
              this.getOrderList();
              setTimeout(() => {
                this.cancelModal = false;
              }, 500);
            } else {
              this.$Message.error(resp.resDesc);
            }
            this.reason = "";
          });
        }
      }, 100);
    },
    frankingHandle() {
      this.frankingModal = false;
      this.cancelModal = true;
    },
    // 订单确认收货
    rogConfirm(id) {
      this.$Modal.confirm({
        content: "<p>请您确认已经收到货物再执行此操作！</p>",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          rogConfirm({ orderNo: id }).then((resp) => {
            if (resp.resCode === 1) {
              this.$Message.success("订单已确认收货");
              this.getOrderList();
            } else {
              this.$Message.error(resp.resDesc);
            }
          });
        },
        onCancel: () => {},
      });
    },
    searchEvent() {
      if (this.searchKey.trim() === "" && this.searchDate.length === 0) {
        this.$Message.warning("请输入订单查询条件!");
      } else {
        //          this.$router.push({
        //            path: '/member/order',
        //            query: {
        //              status: '9'
        //            }
        //          })
        this.tabIndex = "9";
        this.toResult();
      }
    },
    // 搜索结果
    toResult() {
      // 判断搜索条件是否有值
      this.pageIndex = 1;
      this.total = 0;
      this.orderList = [];
      if (this.searchKey.trim() === "" && this.searchDate.length === 0) {
        this.showResult = this.tabIndex === "9" ? true : false;
        this.$Message.warning("请输入订单查询条件!");
      } else {
        this.getOrderList();
      }
    },
    //  根据订单状态获取订单信息
    getOrderList() {
      //日期转换时间戳
      let start = "",
        end = "";
      if (this.searchDate.length > 0 && this.searchDate[0]) {
        start = Math.round(new Date(parseTime(this.searchDate[0])) / 1000);
        end = Math.round(new Date(parseTime(this.searchDate[1])) / 1000);
      }

      getOrderList({
        //订单状态
        status:
          parseInt(this.tabIndex) === 9 || parseInt(this.tabIndex) === -1
            ? ""
            : parseInt(this.tabIndex),
        //关键字搜索
        keyword: this.searchKey.trim(),
        start: start,
        end: end,
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
      }).then((resp) => {
        if (resp.resCode === 1) {
          this.orderList = resp.data.list;
          this.total = resp.data.total;
          this.showResult = this.tabIndex === "9" ? true : false;
        }
      });
    },
    changePage(page) {
      this.pageIndex = page;
      this.getOrderList();
    },
  },
};
</script>

<style scoped>
.box > .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0 !important;
  border-bottom: none;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  color: #000;
  font-size: 12px;
  background: #eeeeee;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  background: #fff;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav:first-child {
  margin-left: 22px;
}

.box > .ivu-card-bordered {
  border-top: none;
}

/*  .ivu-btn-text {
    color: #53a0be !important;
  }
*/
.ivu-btn-text:hover {
  color: #e4393c !important;
}

.form-input {
  width: 200px !important;
}

.form-input .ivu-input {
  height: 20px !important;
}

.search-box {
  margin-top: 15px;
  border-radius: 5px;
  background-color: #fffcf3;
  border: 1px solid #dbdbdb;
}

.search-box div {
  box-sizing: border-box !important;
}

.order-table > .ivu-table-tbody > td {
  height: 40px !important;
  line-height: 40px !important;
}

.datepicker {
  width: 300px;
  box-sizing: border-box !important;
}
</style>
<style>
.datepicker input {
  padding-right: 0 !important;
}

.ivu-table-cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// order.vue?ec30d354